import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useUserRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { ConfirmationModal, SpinnerButton } from '@ospace/shared'

import { Contact } from '../models/Contact'
import { useDissociateMultipleContactMutation } from '../useDissociateContactMutation'

const AlertMessage = ({ contacts }: { contacts: Contact[] }) => {
  return (
    <div>
      <p className='fs-4'>
        Do you want to remove <b>{contacts.length}</b>{' '}
        {contacts.length > 1 ? 'contacts' : 'contact'} from the campaign?{' '}
      </p>
      <div
        className='mt-5'
        style={{
          maxHeight: 350,
          overflowY: 'auto',
        }}
      >
        <section>
          <header className='row'>
            <h5 className='col'>Name</h5>
            <h5 className='col'>Phone/Email</h5>
          </header>
          {contacts.map(({ firstName, lastName, mobilePhone, emailAddress }) => (
            <div className='row' key={`${emailAddress || mobilePhone}`}>
              <span className='col'>{`${firstName} ${lastName}`}</span>
              <span className='col'>{emailAddress || mobilePhone}</span>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}

export const RemoveContactsButton = ({
  contacts,
  setSeletedContacts,
}: {
  contacts: Contact[]
  setSeletedContacts?: any
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const role: userTypes = useUserRole()
  const params: any = useParams()
  const campaignId: number = Number(params?.id)
  const mutation = useDissociateMultipleContactMutation(campaignId)

  const actionHandler = async () => {
    setIsLoading(true)
    const contactIds = contacts.map((contact: Contact) => contact.id)

    await mutation.mutateAsync(contactIds as number[])
    setIsLoading(false)
    setSeletedContacts({})
  }

  return (
    <div className='d-flex'>
      {(role === userTypes.Admin || role === userTypes.ClientManager) && (
        <ConfirmationModal
          alertMessage={<AlertMessage contacts={contacts} />}
          action={actionHandler}
          renderButton={(rp) => (
            <SpinnerButton {...rp} loading={isLoading} variant='danger'>
              Remove
            </SpinnerButton>
          )}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}
